import { CmsReactComponent } from 'components/cms/CmsReactComponent';
import {
    PropertyDefinition
} from "app/library/layout-builder";

import { GoogleMapsProps } from "./types";

export class GoogleMapsDefinitions extends CmsReactComponent<GoogleMapsProps> {

    static schemaName = "google-maps";

    static propertyDefinitions: PropertyDefinition[] = [];
}
